import axios from 'axios';
const work_order_tracker_url = 'work-order-trackers/';
const invoice_tracker_url = 'invoice-trackers/';
const expense_tracker_url = 'expense-trackers/';
const deposit_tracker_url = 'deposit-trackers/';
const reconciliation_tracker_url = 'reconciliation-trackers/';
const inquiry_tracker_url = 'inquiry-trackers/';
const project_tracker_url = 'project-trackers/';
const subd_tracker_url = 'startupblowdown-trackers/';
const estimate_tracker_url = 'estimate-trackers/';
const client_tracker_url = 'client-trackers/';
const tracker_url = 'trackers/';
const email_log_url = 'email-log/';

export default {
  async updateTracker (id, tracker) {
    return axios.patch(tracker_url + `${id}/`, tracker)
    .then((response) => {
      return response.data;
    })
    .catch(err => {
        console.log(err);
    })
  },
  async createInvoiceTracker (tracker) {
    return axios.post(invoice_tracker_url, tracker)
    .then(res => {
      return res.data;
    }).catch(err => {
        console.log(err);
    })
    
  },
  async getInvoiceTracker (id) {
    return axios.get(invoice_tracker_url + `?invoice_pk=${id}`)
    .then((response) => {
      return response.data;
    })
    .catch(err => {
        console.log(err);
    })
  },
  async createWorkOrderTracker (tracker) {
    return axios.post(work_order_tracker_url, tracker)
    .then(res => {
      return res.data;
    }).catch(err => {
        console.log(err);
    })
    
  },
  async getWorkOrderTracker (id) {
    return axios.get(work_order_tracker_url + `?work_order_pk=${id}`)
    .then((response) => {
      return response.data;
    })
    .catch(err => {
        console.log(err);
    })
  },
  async createExpenseTracker (tracker) {
    return axios.post(expense_tracker_url, tracker)
    .then(res => {
      return res.data;
    }).catch(err => {
        console.log(err);
    })
    
  },
  async getExpenseTracker (id) {
    return axios.get(expense_tracker_url + `?expense_pk=${id}`)
    .then((response) => {
      return response.data;
    })
    .catch(err => {
        console.log(err);
    })
  },
  async createDepositTracker (tracker) {
    return axios.post(deposit_tracker_url, tracker)
    .then(res => {
      return res.data;
    }).catch(err => {
        console.log(err);
    })
    
  },
  async getDepositTracker (id) {
    return axios.get(deposit_tracker_url + `?deposit_pk=${id}`)
    .then((response) => {
      return response.data;
    })
    .catch(err => {
        console.log(err);
    })
  },
  async createReconciliationTracker (tracker) {
    return axios.post(reconciliation_tracker_url, tracker)
    .then(res => {
      return res.data;
    }).catch(err => {
        console.log(err);
    })
    
  },
  async getReconciliationTracker (id) {
    return axios.get(reconciliation_tracker_url + `?reconciliation_pk=${id}`)
    .then((response) => {
      return response.data;
    })
    .catch(err => {
        console.log(err);
    })
  },
  async createInquiryTracker (tracker) {
    return axios.post(inquiry_tracker_url, tracker)
    .then(res => {
      return res.data;
    }).catch(err => {
        console.log(err);
    })
    
  },
  async getInquiryTracker (id) {
    return axios.get(inquiry_tracker_url + `?inquiry_pk=${id}`)
    .then((response) => {
      return response.data;
    })
    .catch(err => {
        console.log(err);
    })
  },
  async createProjectTracker (tracker) {
    return axios.post(project_tracker_url, tracker)
    .then(res => {
      return res.data;
    }).catch(err => {
        console.log(err);
    })
    
  },
  async getProjectTracker (id) {
    return axios.get(project_tracker_url + `?project_pk=${id}`)
    .then((response) => {
      return response.data;
    })
    .catch(err => {
        console.log(err);
    })
  },
  async createSubdTracker (tracker) {
    return axios.post(subd_tracker_url, tracker)
    .then(res => {
      return res.data;
    }).catch(err => {
        console.log(err);
    })
    
  },
  async getSubdTracker (id) {
    return axios.get(subd_tracker_url + `?subd_pk=${id}`)
    .then((response) => {
      return response.data;
    })
    .catch(err => {
        console.log(err);
    })
  },
  async createEstimateTracker (tracker) {
    return axios.post(estimate_tracker_url, tracker)
    .then(res => {
      return res.data;
    }).catch(err => {
        console.log(err);
    })
    
  },
  async getEstimateTracker (id) {
    return axios.get(estimate_tracker_url + `?estimate_pk=${id}`)
    .then((response) => {
      return response.data;
    })
    .catch(err => {
        console.log(err);
    })
  },
  async createClientTracker (tracker) {
    return axios.post(client_tracker_url, tracker)
    .then(res => {
      return res.data;
    }).catch(err => {
        console.log(err);
    })
    
  },
  async getClientTracker (id) {
    return axios.get(client_tracker_url + `?client_pk=${id}`)
    .then((response) => {
      return response.data;
    })
    .catch(err => {
        console.log(err);
    })
  },
  async getEmailLog (dateFrom, dateTo, status, page, numberPerPage) {
    const url = email_log_url + `?date_from=${dateFrom}&date_to=${dateTo}&status=${status}&page=${page}&number_per_page=${numberPerPage}&`;
    return axios.get(url)
    .then((response) => {
      return response.data;
    })
    .catch(err => {
        console.log(err);
    })
  },
  async downloadEmailLogCSV (dateFrom, dateTo, status) {
    const url = email_log_url + `csv/?date_from=${dateFrom}&date_to=${dateTo}&status=${status}&`;
    return axios.get(url, { responseType: 'blob' })
    .then((response) => {
      return response.data;
    })
    .catch(err => {
        console.log(err);
    })
  },
}
